import React, { useState, useEffect } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';

import axios from 'axios';

export default function Conversion(props) {
    const { ...rest } = props;

    // Chakra Color Mode
    const cardColor = useColorModeValue('white', 'navy.700');
    const cardShadow = useColorModeValue(
        '0px 18px 40px rgba(112, 144, 176, 0.12)',
        'unset'
    );

    const [imageBase64, setImageBase64] = useState("");
    const [error, setError] = useState(null); // Initialize error state

    const [svgContent, setSvgContent] = useState(null);
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        // Check if selectedOption is not null and has a value field
        if (props.selectedOption && props.selectedOption.value) {
            // Use the selectedOption.value in the API URL
            // const apiUrl = `http://localhost:8000/api/get-crosstalk-venn/?project=${props.selectedOption.value}`;
            // const apiUrl = `http://localhost:8000/api/get-crosstalk-enrichment/?project=${props.selectedOption.value}`;
            // const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
            // const apiUrl = `${api_host}/api/get-crosstalk-venn/?project=${props.selectedOption.value}`;


            // axios.get(apiUrl)
            //     .then(response => {
            //         setImageBase64(response.data.image_base64);
            //     })
            //     .catch(err => {
            //         setError("Failed to fetch image."); // Set error state
            //         console.error("Error fetching image: ", err);
            //     });

            setLoading(true); 

            const api_host = `http://localhost:8000/api/get-crosstalk-cooccur-figure/`;
            const apiUrl = `${api_host}?project=${props.selectedOption.value}`;
            console.log(apiUrl);

            axios.get(apiUrl)
                .then(response => {
                    let svgString = response.data.svg_content;

                    let parser = new DOMParser();
                    let doc = parser.parseFromString(svgString, 'image/svg+xml');
                    let svgElement = doc.querySelector('svg');
                    
                    svgElement.removeAttribute('width');
                    svgElement.removeAttribute('height');

                    setSvgContent(svgElement.outerHTML);  // Assuming the SVG XML content is under the svg_content key
                })
                .catch(err => {
                    setError("Failed to fetch image."); // Set error state
                    console.error("Error fetching image: ", err);
                })
                .finally(() => {
                    setLoading(false);  // Set loading state to false after fetching
                });

        }
    
    }, [props.selectedOption]);

return (
    <Card p='20px' align='center' direction='column' w='100%' {...rest}>
        <div className="App">
            <Box mb={4}>
                <h3>co-ocurrent glycosylation and phosphorylation </h3>
            </Box>
            {/* {imageBase64 && <img src={`data:image/jpeg;base64,${imageBase64}`} alt="description" />} */}
            {loading && <p>Loading...</p>} 
            <div dangerouslySetInnerHTML={{ __html: svgContent }} />
            {error && <p>{error}</p>} {/* Display error message */}
        </div>
    </Card>
);
}
